/**
 * The one place a chat connection is created.
 *  - live: socket.io to Caryn's server. WEBSOCKET FIRST: a websocket is not origin-checked by her server (the gateway's
 *    upgrade handler passes /socket.io straight through), while a polling start goes through the gateway's address list
 *    and fails from any address that is not on it. Polling stays as the fallback.
 *  - mock: an in-page stand-in (src/mock/socket.ts).
 */
import { io, type ManagerOptions, type SocketOptions, type Socket } from 'socket.io-client'
import { IS_MOCK } from '~/config/mode'
import { MockSocket } from '~/mock/socket'

export function createSocket(url: string, opts: Partial<ManagerOptions & SocketOptions>): Socket {
  if (IS_MOCK) return new MockSocket() as unknown as Socket
  return io(url, { ...opts, transports: ['websocket', 'polling'] })
}
